import dianaPic from "@/public/images/artists/diana.png";
import { Artist } from "@/types/types";

export const diana = {
  id: "2",
  name: "Diana",
  image: dianaPic,
  description: `Diana, the "Diva", delivers powerful vocals with a huge range. Her soul-stirring voice brings a touch of warmth and authenticity to every melody, perfect for both soul and powerhouse.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdiana-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Soul", "Dance", "Pop", "RnB"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 59,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
